import type { LegalContent } from "./types";

export const termsEn: LegalContent = {
  seo: {
    title: "Terms of Use - Luxoria",
    description: "The terms that govern your use of the Luxoria HDR conversion app."
  },
  tag: "Legal",
  title: "Terms of Use",
  lastUpdated: "Last updated: June 8, 2026",
  sections: [
    {
      heading: "1. Acceptance of Terms",
      body: "By downloading, installing, or using Luxoria, you agree to these Terms of Use. If you do not agree, please do not use the app."
    },
    {
      heading: "2. Use of Luxoria",
      body: "Luxoria is provided as a tool to convert SDR photos and videos into HDR-ready outputs. You may use the app for lawful personal and professional media conversion."
    },
    {
      heading: "3. User Content",
      body: "You are responsible for the photos and videos you select for conversion. You must have the necessary rights to process the media you choose to use with Luxoria."
    },
    {
      heading: "4. HDR Conversion Results",
      body: "HDR conversion results may vary based on the source media, device, operating system version, display, and viewer app. Luxoria does not guarantee identical results across all files or devices."
    },
    {
      heading: "5. Compatibility and Availability",
      body: "Features and output formats depend on your platform and its HDR capabilities. Some features may not be available on every device or operating system version."
    },
    {
      heading: "6. Prohibited Uses",
      body: "You must not use Luxoria to infringe copyright, violate the rights of others, or for any illegal or improper purpose."
    },
    {
      heading: "7. Intellectual Property",
      body: "Luxoria, including its design, branding, and software, is the property of Axqora and is protected by applicable intellectual property laws. These Terms do not grant you ownership of the app."
    },
    {
      heading: "8. Disclaimer",
      body: "Luxoria is provided \"as is\" without warranties of any kind. We do not warrant that the app will be uninterrupted, error-free, or that conversion results will meet every expectation."
    },
    {
      heading: "9. Limitation of Liability",
      body: "To the extent permitted by law, Axqora is not liable for any indirect, incidental, or consequential damages arising from your use of Luxoria, including loss of media or data."
    },
    {
      heading: "10. Changes to These Terms",
      body: "We may update these Terms of Use as the app evolves. When we make material changes, we will update the date shown above. Continued use of Luxoria indicates acceptance of the updated terms."
    },
    {
      heading: "11. Contact Us",
      body: "If you have questions about these Terms of Use, contact us at axqora@gmail.com."
    }
  ],
  contact: {
    title: "Questions about these terms?",
    body: "Email us at axqora@gmail.com and we will get back to you."
  }
};
